


import newFeatures from '../dashboard/oxxo/newFeatures'
import defaultGnp from '../dashboard/gnp/default'
import defaultCaffenio from '../dashboard/caffenio/default'
import defaultIamsa from '../dashboard/iamsa/default'
import defaultBenavides from '../dashboard/benavides/default'
import defaultProfuturo from '../dashboard/profuturo/default'
import demoJac from '../dashboard/jac/demo'

// Oxxo
import defaultOxxo from '../dashboard/oxxo/default'
import extendedOxxo from '../dashboard/oxxo/extended'
import weeklyOxxo from '../dashboard/oxxo/weekly'

// Oxxo Retails
import defaultOxxoRetail from '../dashboard/oxxoRetails/default'
import defaultOxxoMetas from './oxxoRetails/metas'

// Hospitales angeles
import demoHa from '../dashboard/ha/dashboards/demo'
import socialListeningHa from './ha/dashboards/socialListening'


// honda
import defaultHonda from '../dashboard/honda/default'

import defaultNetpay from '../dashboard/netpay/default'

// Hospitales angeles
import demoMedicasur from '../dashboard/medicasur/default'

// Bupa
import defaultBupa from '../dashboard/bupa/default'
import externalBupa from '../dashboard/bupa/external'

// Mitsubishi
import mitsuCxo from '../dashboard/mitsubishi/cxo'
import mitsuDistribuidor from '../dashboard/mitsubishi/distribuidor'
import mitsuDistribuidorPosventa from '../dashboard/mitsubishi/distribuidorPosventa'
import mitsuDistribuidorVenta from '../dashboard/mitsubishi/distribuidorVenta'
import mitsuNacionalPosventa from '../dashboard/mitsubishi/nacionalPosventa'
import mitsuNacionalVenta from '../dashboard/mitsubishi/nacionalVenta'
import mitsuZonalPosventa from '../dashboard/mitsubishi/zonalPosventa'
import mitsuZonalVenta from '../dashboard/mitsubishi/zonalVenta'
import mitsuNacionalReparacion from '../dashboard/mitsubishi/nacionalReparacion'
import mitsuZonalReparacion from '../dashboard/mitsubishi/zonalReparacion'

// Suzuki
import suzuCxo from '../dashboard/suzuki/cxo'
import suzuDistribuidor from '../dashboard/suzuki/distribuidor'
import suzuDistribuidorPosventa from '../dashboard/suzuki/distribuidorPosventa'
import suzuDistribuidorVenta from '../dashboard/suzuki/distribuidorVenta'
import suzuNacionalPosventa from '../dashboard/suzuki/nacionalPosventa'
import suzuNacionalVenta from '../dashboard/suzuki/nacionalVenta'
import suzuZonalPosventa from '../dashboard/suzuki/zonalPosventa'
import suzuZonalVenta from '../dashboard/suzuki/zonalVenta'

// Byd
import bydCxo from '../dashboard/byd/cxo'
import bydNacionalServicio from '../dashboard/byd/nacionalServicio'
import bydNacionalVenta from '../dashboard/byd/nacionalVenta'
import bydNacionalTestDrive from '../dashboard/byd/nacionalTestDrive'

import { SECTION_KEYS } from '@utils/access/perms'


/*import bydDistribuidor from '../dashboard/byd/distribuidor'
import bydDistribuidorPosventa from '../dashboard/byd/distribuidorPosventa'
import bydDistribuidorVenta from '../dashboard/byd/distribuidorVenta'
import bydZonalPosventa from '../dashboard/byd/zonalPosventa'
import bydZonalVenta from '../dashboard/byd/zonalVenta'*/


export interface DashboardList {
    [id: string]: DasboardConfig
}

export interface DashboardConfigInfo {
    path: string
    title: string
    reducerKey: string
    dashboards: DashboardList
}

export interface ClientDashboardConfig {
    [DASHBOARDS.DEFAULT]: DashboardConfigInfo
    [id: string]: DashboardConfigInfo
}

export interface DashboardCustomFilters {
    [id: string]: Filters
}

export interface ClientDashboardsList {
    [client: string]: ClientDashboardConfig
}

export enum DASHBOARDS {
    // Base Dashboard
    DEFAULT = 'dashboard',
    // Oxxo Extended dashboard
    OXXO_EXT = 'extended-dashboard', 
    // Oxxo Weekly dashboard
    OXXO_WEEKLY = 'weekly-dashboard', 
    // Social Listening Dashboard
    SOCIAL_LISTENING = 'social-listening',

    OXXO_METAS = 'metas-dashboard',
}

export const DASHBOARDS_CONFIGS: ClientDashboardsList = {
    oxxo: {
        [DASHBOARDS.DEFAULT]: {
            path: '/dashboard',
            title: 'Panel de indicadores',
            reducerKey: 'dashboard',
            dashboards: { demo: defaultOxxo, newFeatures: newFeatures }
        },
        [DASHBOARDS.OXXO_EXT]: {
            path: '/extended-dashboard',
            title: 'Preguntas complementarias',
            reducerKey: SECTION_KEYS.EXTENDED_DASHBOARD,
            dashboards: { extended: extendedOxxo }
        },
        [DASHBOARDS.OXXO_WEEKLY]: {
            path: '/weekly-dashboard',
            title: 'Dahboard semanal',
            reducerKey: SECTION_KEYS.WEEKLY_DASHBOARD,
            dashboards: { extended: weeklyOxxo }
        },
    },
    oxxoretail: {
        [DASHBOARDS.DEFAULT]: {
            path: '/dashboard',
            title: 'Dashboard',
            reducerKey: 'dashboard',
            dashboards: { 
                demo: defaultOxxoRetail,
                //Metas: defaultOxxoMetas,
            }
        },

        [DASHBOARDS.OXXO_METAS]: {
            path: '/metas-dashboard',
            title: 'Dashboard de Metas',
            reducerKey: SECTION_KEYS.METAS_DASHBOARD,
            dashboards: { extended: defaultOxxoMetas, }
        },


    },
    mitsubishi: {
        [DASHBOARDS.DEFAULT]: {
            path: '/dashboard',
            title: 'Dashboard',
            reducerKey: 'dashboard',
            dashboards: {
                'cxo': mitsuCxo,
                'nacionalVenta': mitsuNacionalVenta,
                'nacionalPosventa': mitsuNacionalPosventa,
                'nacionalReparacion': mitsuNacionalReparacion,
                'zonalVenta': mitsuZonalVenta,
                'zonalPosventa': mitsuZonalPosventa,
                'zonalReparacion': mitsuZonalReparacion,
                'distribuidorVenta': mitsuDistribuidorVenta,
                'distribuidorPosventa': mitsuDistribuidorPosventa,
                'distribuidor': mitsuDistribuidor
            }
        }
    },
    suzuki: {
        [DASHBOARDS.DEFAULT]: {
            path: '/dashboard',
            title: 'Dashboard',
            reducerKey: 'dashboard',
            dashboards: {
                'cxo': suzuCxo,
                'nacionalVenta': suzuNacionalVenta,
                'nacionalPosventa': suzuNacionalPosventa,
                'zonalVenta': suzuZonalVenta,
                'zonalPosventa': suzuZonalPosventa,
                'distribuidor': suzuDistribuidor,
                'distribuidorVenta': suzuDistribuidorVenta,
                'distribuidorPosventa': suzuDistribuidorPosventa
            }
        }
    },
    ha: {
        [DASHBOARDS.DEFAULT]: {
            path: '/dashboard',
            title: 'Dashboard',
            reducerKey: 'dashboard',
            dashboards: { demo: demoHa }
        },
        [DASHBOARDS.SOCIAL_LISTENING]: {
            path: '/social-listening',
            title: 'Social Listening',
            reducerKey: 'social-listening',
            dashboards: { socialListening: socialListeningHa }
        }
    },
    honda: {
        [DASHBOARDS.DEFAULT]: {
            path: '/dashboard',
            title: 'Dashboard',
            reducerKey: 'dashboard',
            dashboards: { demo: defaultHonda }
        }
    },
    netpay: {
           [DASHBOARDS.DEFAULT]: {
               path: '/dashboard',
               title: 'Dashboard',
               reducerKey: 'dashboard',
               dashboards: { demo: defaultNetpay }
           }
       },
    
    medicasur: {
        [DASHBOARDS.DEFAULT]: {
            path: '/dashboard',
            title: 'Dashboard',
            reducerKey: 'dashboard',
            dashboards: { demo: demoMedicasur }
        }
    },
    gnp: {
        [DASHBOARDS.DEFAULT]: {
            path: '/dashboard',
            title: 'Dashboard',
            reducerKey: 'dashboard',
            dashboards: { demo: defaultGnp }
        }
    },
    profuturo: {
        [DASHBOARDS.DEFAULT]: {
            path: '/dashboard',
            title: 'Dashboard',
            reducerKey: 'dashboard',
            dashboards: {
                demo: defaultProfuturo,
                marketing: defaultProfuturo,
                //corporativo: defaultProfuturo,
                //regional: defaultProfuturo,
                //operacional: defaultProfuturo,
                //asesor: defaultProfuturo,
                //lider: defaultProfuturo
            }
        }
    },
    jac: {
        [DASHBOARDS.DEFAULT]: {
            path: '/dashboard',
            title: 'Dashboard',
            reducerKey: 'dashboard',
            dashboards: {
                demo: demoJac,
            }
        }
    },
    caffenio: {
        [DASHBOARDS.DEFAULT]: {
            path: '/dashboard',
            title: 'Dashboard',
            reducerKey: 'dashboard',
            dashboards: { demo: defaultCaffenio }
        }
    },
    iamsa: {
        [DASHBOARDS.DEFAULT]: {
            path: '/dashboard',
            title: 'Dashboard',
            reducerKey: 'dashboard',
            dashboards: { demo: defaultIamsa }
        }
    },
    bupa: {
        [DASHBOARDS.DEFAULT]: {
            path: '/dashboard',
            title: 'Dashboard',
            reducerKey: 'dashboard',
            dashboards: { 
                demo: defaultBupa,
                external: externalBupa 
            }
        }
    },
    byd: {
        [DASHBOARDS.DEFAULT]: {
            path: '/dashboard',
            title: 'Dashboard',
            reducerKey: 'dashboard',
            dashboards: {
                'cxo': bydCxo,
                'nacionalVenta': bydNacionalVenta,
                'nacionalPosventa': bydNacionalServicio,
                'nacionalTestDrive': bydNacionalTestDrive,
                /*'zonalVenta': bydZonalVenta,
                'zonalPosventa': bydZonalPosventa,
                'distribuidor': bydDistribuidor,
                'distribuidorVenta': bydDistribuidorVenta,
                'distribuidorPosventa': bydDistribuidorPosventa*/
            }
        }
    },
    benavides: {
        [DASHBOARDS.DEFAULT]: {
            path: '/dashboard',
            title: 'Dashboard',
            reducerKey: 'dashboard',
            dashboards: { demo: defaultBenavides }
        }
    },
}